import { Map } from 'immutable';

import {SET_CATEGORIES, COMMON_SET_ORGANIZATIONS, SET_MAP_BOUNDS, SET_MAP_CENTER} from './actions';

const defaultState = {
    categories: [],
    organizations: [],
    bounds: null,
    center: null,
}

const common = (state = Map(defaultState), action) => {
  switch (action.type) {
    case SET_CATEGORIES:
        return state.setIn(['categories'], action.payload.categories);
    case COMMON_SET_ORGANIZATIONS:
        return state.setIn(['organizations'], action.payload.organizations);
    case SET_MAP_BOUNDS:
        return state.setIn(['bounds'], action.payload.bounds);
    case SET_MAP_CENTER:
        return state.setIn(['center'], action.payload.center);
    default:
        return state;
  }
}

export default common;


// WEBPACK FOOTER //
// ./src/shared/reducer.js